const state = {
  isAuthorized: false,
  id: null,
  firstName: null,
  lastName: null,
  groups: []
};

export default state;
